import { render, staticRenderFns } from "./CustomerManagement.vue?vue&type=template&id=d84bdc42"
import script from "./CustomerManagement.vue?vue&type=script&lang=ts"
export * from "./CustomerManagement.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports